import { ProfileModel } from './profile.model';
import { RequestHeaderModel } from './request-header.model';
import { RequestLineModel } from './request-line.model';
import { RichDataModel } from './rich-data.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class SalesHeader {
  id: number;
  document_type: 'Order' | 'Invoice';
  document_no: string | null;
  no_series: string | null;
  posting_no_series: string | null;
  document_date: Date | string; // İlk oluşturmada Now gönder. Hata aldın tekrar göndermen gerekecek buna dokunma.
  external_document_no: string | null;
  package_tracking_no: string | null;

  payment_method_code: 'CreditCard' | 'Cash' | 'Coupon' | 'Bonus';
  paymentChannel: 'CreditCard' | 'Paypal' | 'Stripe' | 'Garanti' | 'IkeaPos' | 'PAYTR';

  locale: string; // profile.locale
  client_id: 0;
  hotel_id: number;
  hotel_name: string;
  request_id: number; // You must post request before create this data. Add the id from post request's response.

  profile_id: number;
  name: string; // profile.first_name
  sur_name: string; // profile.last_name
  identity_number: string; // profile.identity_number
  email: string; // profile.e_mail
  gsm_number: string; // profile.phone_number
  address: string; // profile.address
  zip_code: string;
  city: string;
  country: string;
  ip: string | null;
  registration_date: Date | string;  //Profilin Kayıt Tarihi Profile.CreatedAt
  last_login_date: Date | string; //Profilin Son Giriş Tarihi Profile.ModifyAt

  due_date: Date | null; // Eğer bu sipariş ileri tarihli ödemesi olan bir sipariş ise bu alnı dolduracağız. M: Boş gönder
  order_date: Date | string; // Sipariş tarihi M: Her Seferinde now gönder
  posting_date: Date | null; // Deftere Nakil Tarihi M: Boş gönder tahsilat sonrası ben koyacağım.
  posting_description: string | null; // Deftere Nakil Açıklaması M: Boş gönder gerekirse ben dolduracağım.

  shortcut_dimension_1_code: string | null;
  shortcut_dimension_2_code: string | null;

  tax_liable: boolean; // false
  tax_area: string | null;
  tax_registration_number: string | null;

  status: string | null;  // Bunu siparişin durumunu takip etmek için kullanacağız M: Şimdilik boş gönder. Ben yöneticem
  campaign_no: string; // Kampanya No M: Kampanya satışı ise buraya koyabilirsin default boş gönder
  currency: string;  // Döviz Kodu ISO4217 (https://www.xe.com/iso4217.php)
  currency_factor: number | null;  // Döviz Kuru M: Şimdilik boş gönder. Ben dolduracağım.
  salesperson_code: string | null;  // Satış Personeli M: Şimdilik boş gönder
  no_of_printed: number; // Yazdırılma adedi M: Şimdilik boş gönder

  invoice_discount_calculation: 'None' | '%' | 'LineAmount';
  invoice_discount_value: number;
  invoice_discount_amount: number; // Fatura iskontosu tutarı M: burayada hesaplanana indirim tutarı
  exc_invoice_amount: number;  // KDV ve indirimler düşülmüş fatura tutarı
  vat_amount: number;    // KDV Tutarı M: Toplam KDV tutaru
  invoice_amount: number; // KDV dahil indirimler düşülmüş toplam tutar Including VAT M: Indirimler KDV'ye konu olmaz.

  shipping_no: string | null; // Irsaliye No. M: Boş gönder
  reason_code: string | null; // Neden kodu M: Boş gönder
  transport_method: string; // Taşıma Methodu M: bunu proje bazlı değerlendirip kullanabiliriz.

  note: string;

  reserve: boolean | null; // Rezerve et Şimdilik null
  reversed: boolean; //Ters Kaydet M: İade durumunda siparişi işaretleyeceğiz

  responsibility_center: string; /* Sorumluluk Merkezi M: Sorumluluk merkezlerine sipariş oluşturmak gerekirse
    bu alanı kullanacağız. Menu Section Name*/

  shipped: boolean; // Sevk edildi M: ilk oluşturmada false gönder. Bunu true yapan gerekirse ayrı bir api yazarız.
  requested_delivery_date: Date | string; // Talep edilen teslim tarihi M: Teslim için misafirin talep ettiği zamanı buraya yazarsın.
  promised_delivery_date: Date | string; // Taahhüt Edilen Teslim Tarihi M: Üstteki ile aynısını koy.
  late_order_shipping: boolean; // Gecikmiş Sipariş Sevkiyatı M: boş gönder. bunun için de gerekirse api yapılabilir.

  assigned_user_id: number; // Atanan Kullanıcı Kimliği M: sipariş geldi hangi kuryeye atanacak ise onun adı.
  shipping_type: 'Staff' | 'Contractual Carrier' | 'Customer' | 'Customer Carrier' | 'Other'; /* ENU=" ,Staff,Contractual
    Carrier,Customer,Customer Carrier,Other";TRK=" ,Personelimiz,Anlaşmalı Kargo,Müşteri Kendisi,Müşteri Kargo,Diğer"
    M: Duruma göre Staff yada Customer diyelim şimdilik. */
  shipped_not_invoiced: boolean; // Sevk Edilmiş Faturalanmamış M: 0 gönder ben hesaplayacağım
  completely_shipped: boolean; // Tamamen Sevk Edildi M: 0 gönder ben hesaplayacağım

  cardHolderName: string;
  cardNumber: string;
  expireYear: string;
  expireMonth: string;
  cvc: string;

  sent_as_email: boolean; // Mail Olarak Gönder M : true gönder
  dimension_set_id: number; // Boyut Seti Kimliği M: bunu şimdilik 0 gönder.
  last_email_sent_time: Date | null;
  last_email_sent_status: 'Not Sent' | 'In Process' | 'Finished' | 'Error' | null;

  redirect_success_url: string;
  redirect_un_success_url: string;
  payment_status: string | null; //Ödeme Durmu M: boş
  card_association: string | null; //MASTER_CARD M: boş
  card_family: string | null; //Bonus M: Boş
  bin_code: string | null; //Kredi kartının ilk 6 hanesi
  last_four_digits: string | null; //Kartın Son 4 hanesi
  installment: number | null; //Taksit M: 1
  response: number[] | null; //Ödeme işleminin Sonucu M: Bunu boş

  bill_to_name: string; //Faturalanacak Adres Adı
  bill_to_address: string; //Faturalacak Adres
  bill_to_zip_code: string; //Faturalanacak Adres Posta Kodu
  bill_to_city: string; //Faturalanacak Adres Şehir
  bill_to_country: string; //Faturalanacak Adres Ülke

  created_at: Date | string;
  created_by: string;
  updated_at: Date | string;
  updated_by: string;
  sales_lines: SalesLine[];

  constructor(request: RequestHeaderModel, profile: ProfileModel, rData: RichDataModel) {
    this.id = 0;
    this.document_type = 'Order';
    this.document_no = null;
    this.no_series = null;
    this.posting_no_series = null;
    this.document_date = new Date().toISOString();
    this.external_document_no = null;
    this.package_tracking_no = null;

    // Must be added when called
    this.payment_method_code = null;
    this.paymentChannel = null;
    this.invoice_discount_calculation = 'None';
    this.invoice_discount_value = 0;
    this.invoice_discount_amount = 0;
    this.exc_invoice_amount = 0;
    this.vat_amount = 0;
    this.invoice_amount = 0;
    this.sales_lines = [];
    // End

    // Must be added if customer will pay online
    this.cardHolderName = null;
    this.cardNumber = null;
    this.expireYear = null;
    this.expireMonth = null;
    this.cvc = null;
    this.redirect_success_url = null;
    this.redirect_un_success_url = null;
    //End

    this.bill_to_address = request.room_no;
    this.bill_to_city = rData.city;
    this.bill_to_country = rData.country;
    this.bill_to_name = request.profile_name;
    this.bill_to_zip_code = request.room_no.split('Zip: ')[1];

    this.client_id = 0;
    this.hotel_id = profile.hotel_id;
    this.hotel_name = rData.name;
    this.request_id = request.id;
    this.profile_id = profile.id;
    this.name = profile.first_name;
    this.sur_name = profile.last_name;
    this.locale = localStorage.getItem('userLang');
    this.identity_number = profile.id_no;
    this.email = profile.e_mail;
    this.gsm_number = profile.phone_no;
    this.address = request.room_no;
    this.zip_code = profile.post_code;
    this.city = rData.city;
    this.country = rData.country;
    this.ip = null;
    this.due_date = null;
    this.order_date = new Date().toISOString();
    this.posting_date = null;
    this.posting_description = null;
    this.shortcut_dimension_1_code = null;
    this.shortcut_dimension_2_code = null;
    this.tax_liable = null;
    this.tax_area = null;
    this.tax_registration_number = null;
    this.status = null;
    this.campaign_no = null;
    this.currency = rData.currency_code.replace('€', 'EUR').replace('$', 'USD').replace('TL', 'TRY')
      .replace('₺', 'TRY').replace('£', 'GBP');
    this.currency_factor = null;
    this.salesperson_code = null;
    this.no_of_printed = null;
    this.shipping_no = null;
    this.reason_code = null;
    this.transport_method = null;
    this.note = request.note || '';
    this.reserve = null;
    this.reversed = false;
    this.responsibility_center = request.menu_section_name;
    this.shipped = false;
    this.requested_delivery_date = new Date().toISOString();
    this.promised_delivery_date = new Date().toISOString();
    this.late_order_shipping = null;
    this.assigned_user_id = null;
    this.shipping_type = 'Staff';
    this.shipped_not_invoiced = false;
    this.completely_shipped = false;
    this.sent_as_email = true;
    this.dimension_set_id = null;
    this.last_email_sent_time = null;
    this.last_email_sent_status = null;
    this.registration_date = profile.created_at;
    this.last_login_date = profile.updated_at;
    this.payment_status = null;
    this.card_association = null;
    this.card_family = null;
    this.bin_code = null;
    this.last_four_digits = null;
    this.installment = 1;
    this.response = null;
    this.created_at = new Date().toISOString();
    this.created_by = `${profile.first_name} ${profile.last_name}`;
    this.updated_at = new Date().toISOString();
    this.updated_by = `${profile.first_name} ${profile.last_name}`;
  }
}

export class SalesLine {
  id: number;
  document_id: number;
  request_header_id: number;
  menu_item_id: number;
  request_line_id: number;
  document_type: 'Order' | 'Invoice';
  line_no: number; //Kendi içindeki sıra no M:10000 arttırarak gönder istersen.
  type: 'Item' | 'Delivery' | 'Reward'; //ürün türü M: Item, Delivery, (Ürün, Kurye)
  no: string; // Ürün No M: MenuItemCatalogPriceID (ürün ise), Hizmet durumunda 15MIL
  description: string; //Açıklama M: Bunu detaylı ürün adı.
  note: string;
  cross_reference_type: 'Customer' | 'Vendor' | 'Bar Code'; /* Çapraz Referans Türü
    (ENU=" ,Customer,Vendor,Bar Code";TRK=" ,Müşteri,Satıcı,Barkod")M: boş */
  cross_reference_no: string | null;
  location_code: string | null; //Konum Kodu M: Boş gönder
  posting_date: Date | null; //Deftere Nakil Tarihi M: Boş gönder ben dolduracağım
  shipment_date: Date | null; //Sevk İrsaliyesi Tarihi M: Boş gönder. Belki api ile zamamı doldurabiliriz
  item_type: string; //Gruplama için kullanılacak Payment'da kullanılıyor. Menu Section
  item_group_name: string;  //Category 1 Menu Category
  item_category_name: string; //Category 2 Menu Item

  variant_code: string;  //Varyant Kodu M: Size alnını gönder. Ürünleri gruplamak için
  unit_of_measure: string;
  quantity: number;
  unit_price: number;
  currency_code: string;
  currency_factor: number | null;

  unit_cost_lcy: number | null;
  unit_cost: number | null; //Birim Maliyet M: Boş gönder

  line_discount_calculation: 'None' | '%' | 'LineAmount'; //Satır İskonto Hesaplaması Indirim türü yüzdesel mi tutarsal mı?
  line_discount_p: number; //Satır İskonto %
  line_discount_amount: number; //Satır İskonto Tutarı
  inv_discount_amount: number; /* Fat. İskonto Tutarı (Satır bazında bölünüyor) tutarsal 100 TL fatura
    iskontosu uyguladın 7 satır var. virgülden son 2 hane yeterli. */
  amount: number; //Toplam Tutar KDV hariç indirim yok
  line_amount: number;  //Toplam tutar indirim (satır indirimi) düşülmüş
  vat_identifier: number; //KDV Tanıtıcı % 2 KDV ise 2 yazacak
  vat_amount: number; //KDV Tutarı (fatura indirimini de dahil edeceğiz)
  amount_including_vat: number; //KDV Dahil Tutar : Line Amount + VAT Amount

  outstanding_quantity: number | null;  //Bekleyen Miktar M: Boş gönder
  outstanding_amount_lcy: number | null; //Bekleyen Tutar (LPB) M: Boş gönder
  qty_to_invoice: number | null; //Faturalanacak Mkt. M: Boş gönder
  qty_to_ship: number | null; //Sevk Edilecek Mkt. M: Boş gönder
  qty_shipped_not_invoiced: number | null; //Sevk Edilmiş Faturalanmamış Mkt. M: Boş gönder
  shipped_not_invoiced: number | null;  //Sevk Edilmiş Faturalanmamış M:Boş gönder
  shipped_not_invoiced_lcy: number | null; //Sevk Edilmiş Faturalanmamış (LPB) KDV Dahil M: Boş gönder
  shipped_not_inv_lcy_no_vat: number | null; //Sevk Edildi Faturalanmadı (LPB) M: boş gönder
  quantity_shipped: number | null; //Sevk Edilen Miktar M: boş gönder
  quantity_invoiced: number | null; //Faturalanan Miktar M: boş gönder
  reserved_quantity: number | null; //Reserved Quantity M: Boş gönder
  profit_p: number | null;//Kar % M: Boş Gönder
  gross_weight: number | null; //Brüt Ağırlık M: Boş
  net_weight: number | null;  //Net Ağırlık M: Boş
  shortcut_dimension_1_code: string | null; //Boyut 1 M:Boş
  shortcut_dimension_2_code: string | null; //Boyut 2 M:Boş
  dimension_set_id: number | null; //Boyut Seti Kimliği M:Boş

  responsibility_center: string; //Sorumluluk Merkezi M: Menu Section Name

  transport_method: string | null; //Taşıma Yöntemi M: Boş
  completely_shipped: boolean | null; //Tamamen Sevk Edildi M: Boş
  requested_delivery_date: Date | null; //Talep edilen teslim tarihi M: Boş
  promised_delivery_date: Date | null; //Taahhüt Edilen Teslim Tarihi M: Boş
  planned_delivery_date: Date | null; //Planlanmış Teslim Tarihi M: Boş
  planned_shipment_date: Date | null; //Planlanmış Sevkiyat Tarihi M: Boş
  shipping_agent_code: string | null; //Sevkiyat Aracısı Kodu M: Boş
  production_date: Date | null; //Üretim Tarihi M: Boş
  expiration_date: Date | null; //Son Kullanma Tarihi M: Boş

  created_at: Date | string; //Oluşturulma Tarihi
  created_by: string; //siparişi Oluşturan
  updated_at: Date | string; //Sipariş değişik tarihi
  updated_by: string; //Sipariş değiştiren

  constructor(
    request: RequestHeaderModel,
    line: RequestLineModel,
    profile: ProfileModel,
    index: number,
    discount: {
      type: 'None' | '%' | 'LineAmount';
      discountAmount: number;
      basePrice: number;
      invoiceDiscount: number;
    },
    vat: number = 0
  ) {

    const percentage = (partialValue: number, totalValue: number): number => (100 * partialValue) / totalValue;

    this.line_discount_calculation = discount.type;

    this.amount = discount.basePrice;

    this.line_discount_amount = discount.basePrice - (discount.basePrice - (discount.discountAmount || 0));

    this.line_discount_p = this.line_discount_amount ? percentage(this.line_discount_amount, this.amount) : 0;

    this.inv_discount_amount = discount.invoiceDiscount ? discount.invoiceDiscount : 0;
    this.line_amount = (this.amount - this.line_discount_amount);
    this.vat_identifier = vat;
    this.vat_amount = Math.round((this.line_amount * vat) * 100) / 100;
    this.amount_including_vat = this.line_amount + this.vat_amount;


    this.id = 0;
    this.document_id = 0;
    this.request_header_id = request.id;
    this.menu_item_id = request.menu_item_id;
    this.request_line_id = line.id;
    this.document_type = 'Order';
    this.line_no = index * 10000;
    this.type = null;
    this.no = null;
    this.description = line.name;
    this.note = line.note || '';
    this.variant_code = line.unit_of_measure || '';
    this.cross_reference_type = null;
    this.cross_reference_no = null;
    this.location_code = null;
    this.posting_date = null;
    this.shipment_date = null;
    this.item_type = request.menu_section_name;
    this.item_group_name = request.menu_category_name;
    this.item_category_name = request.menu_item_name;
    this.unit_of_measure = line.unit_of_measure || '';
    this.quantity = line.quantity;
    this.unit_price = line.unit_price;
    this.currency_code = line.currency_code.replace('€', 'EUR').replace('$', 'USD').replace('TL', 'TRY')
      .replace('₺', 'TRY').replace('£', 'GBP');
    this.currency_factor = 0;
    this.unit_cost_lcy = 0;

    this.outstanding_quantity = null;
    this.outstanding_amount_lcy = null;
    this.qty_to_invoice = null;
    this.qty_to_ship = null;
    this.qty_shipped_not_invoiced = null;
    this.shipped_not_invoiced = null;
    this.shipped_not_invoiced_lcy = null;
    this.shipped_not_inv_lcy_no_vat = null;
    this.quantity_shipped = null;
    this.quantity_invoiced = null;
    this.reserved_quantity = null;
    this.unit_cost = null;
    this.profit_p = null;
    this.gross_weight = null;
    this.net_weight = null;
    this.shortcut_dimension_1_code = null;
    this.shortcut_dimension_2_code = null;
    this.dimension_set_id = null;

    this.responsibility_center = request.menu_section_name;

    this.transport_method = null;
    this.completely_shipped = null;
    this.requested_delivery_date = null;
    this.promised_delivery_date = null;
    this.planned_delivery_date = null;
    this.planned_shipment_date = null;
    this.shipping_agent_code = null;
    this.production_date = null;
    this.expiration_date = null;

    this.created_at = new Date().toISOString();
    this.created_by = `${profile.first_name} ${profile.last_name}`;
    this.updated_at = new Date().toISOString();
    this.updated_by = `${profile.first_name} ${profile.last_name}`;
  }
}
